import { FC } from "react";
import { styled } from "styled-components";
import { FaCheck } from "react-icons/fa";
import { ReportVersionStatus } from "app/api/graph/types";
import { reportVersionStatusLabel } from "app/api/graph/strings";

const Container = styled.div`
    overflow-x: auto;
    width: 100%;
    display: flex;
    align-items: start;
`;

const Connector = styled.div<{ $active: boolean }>`
    flex: 1;
    height: 2px;
    margin-top: 19px;
    background-color: ${({ $active }) => ($active ? "var(--bs-primary)" : "var(--bs-secondary)")};
`;

const Label = styled.span<{ $active: boolean }>`
    font-size: 12px;
    line-height: 1.3;
    color: ${({ $active }) => ($active ? "var(--bs-primary)" : "var(--bs-secondary)")};
    word-break: break-word;
    font-weight: ${({ $active }) => ($active ? "600" : "400")};
    text-align: center;
    margin-top: 0.5rem;
    max-width: 80px;
`;

const Circle = styled.div<{ $active: boolean }>`
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    font-size: 14px;
    background-color: ${({ $active }) => ($active ? "var(--bs-primary)" : "var(--bs-body)")};
    color: ${({ $active }) => ($active ? "#FFF" : "var(--bs-secondary)")};
    border-color: ${({ $active }) => ($active ? "var(--bs-primary)" : "var(--bs-secondary)")};
    border-width: 2px;
    border-style: solid;
    user-select: none;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
`;

const CircleContainer = styled.div`
    min-width: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ItemContainer = styled.div<{ $isLast: boolean }>`
    display: flex;
    align-items: start;
    flex: ${({ $isLast }) => ($isLast ? "0 0 auto" : "1 1 0")};
`;

type Props = {
    currentStatus: ReportVersionStatus;
};

const statusOrder: ReportVersionStatus[] = [
    ReportVersionStatus.Scoping,
    ReportVersionStatus.Prerequisites,
    ReportVersionStatus.Booked,
    ReportVersionStatus.Testing,
    ReportVersionStatus.Reporting,
    ReportVersionStatus.QualityAssurance,
    ReportVersionStatus.Published,
];

export const ReportVersionStatusHorizontalTimeline: FC<Props> = ({ currentStatus }) => {
    const currentStatusIndex = statusOrder.indexOf(currentStatus);

    return (
        <Container>
            {statusOrder.map((status, index) => {
                const isComplete = index <= currentStatusIndex;
                const isLast = index === statusOrder.length - 1;

                return (
                    <ItemContainer key={status} $isLast={isLast}>
                        <CircleContainer>
                            <Circle $active={isComplete}>{isComplete ? <FaCheck /> : index + 1}</Circle>

                            <Label $active={isComplete}>{reportVersionStatusLabel(status)}</Label>
                        </CircleContainer>

                        {!isLast && <Connector $active={isComplete} />}
                    </ItemContainer>
                );
            })}
        </Container>
    );
};
